import {
  bodyLock,
  mayHideFloatingButtons,
  restoreFloatingButtons,
  transitionClose,
  transitionOpen
} from "./transitions.js";
import {clearAllBodyScrollLocks} from "body-scroll-lock";


const mainNavigation = document.querySelector('#main-navigation');
const mainNavItems = Array.from(
  mainNavigation ? mainNavigation.querySelectorAll('.level-0') : []
).map(item => {
  return {
    original: item,
    button: item.querySelector('button'),
    wrapper: item.querySelector('.nav-item-wrapper'),
    closeButton: item.querySelector('.nav-group-close'),
  }
})
const searchButtons = Array.from(document.querySelectorAll('.top-bar-search-button'))
const burgerButton = document.querySelector('.top-bar-burger')

const searchOverlay = document.querySelector('.overlay-search')
const mobileMenuOverlay = document.querySelector('.overlay-mobile-menu')
const closeSearchButton = searchOverlay.querySelector('[data-search-close]')

const topBarSubNav = document.querySelectorAll('.top-bar-navigation .menu-item-has-children > a')

const someMenuOpen = () => {
  window.dispatchEvent(new CustomEvent('widgets:close'))
  mayHideFloatingButtons()
}

const someMenuClose = () => {
  restoreFloatingButtons()
}


const closeSearchOverlay = async () => {
  someMenuClose()
  await transitionClose('overlay-search', document.body, searchButtons, searchOverlay)

  clearAllBodyScrollLocks()
}

const openSearchOverlay = async () => {
  someMenuOpen()
  await transitionOpen('overlay-search',document.body, searchButtons, searchOverlay)
}

const closeMobileMenuOverlay = async () => {
  await transitionClose('overlay-mobile-menu', document.body, burgerButton, mobileMenuOverlay)
}

const openMobileMenuOverlay = async () => {
  someMenuOpen()
  await transitionOpen('overlay-mobile-menu', document.body, burgerButton, mobileMenuOverlay)
}

const closeMainNavItems = async () => {
  someMenuClose()
  for (const item of mainNavItems) {
    if (window.innerWidth > 1024) {
      transitionClose('nav-item', item.original, item.button, item.wrapper)
    } else {
      await transitionClose('nav-item', item.original, item.button, item.wrapper)
    }
  }
}

const openMainNavItem = async item => {
  someMenuOpen()
  await transitionOpen('nav-item', item.original, item.button, item.wrapper)
}

const closeTopBarSubNav = async () => {
  someMenuClose()
  topBarSubNav.forEach(item => {
    item.parentElement.classList.remove('open')
  })
}

closeSearchButton.addEventListener('click', async e => await closeSearchOverlay())

searchButtons.forEach(searchButton => searchButton.addEventListener('click', async e => {
  e.preventDefault()

  await closeMainNavItems()
  await closeMobileMenuOverlay()

  const isOpen = document.body.classList.contains('overlay-search-open')

  console.log('open search', isOpen)

  isOpen ? await closeSearchOverlay() : await openSearchOverlay()

  if (!isOpen) {
    searchOverlay.querySelector('input').focus()
    bodyLock(searchOverlay)
  }
}))

burgerButton.addEventListener('click', async e => {
  e.preventDefault()

  const isOpen = document.body.classList.contains('overlay-mobile-menu-open')

  await closeMainNavItems()
  await closeSearchOverlay()

  isOpen ? await closeMobileMenuOverlay() : await openMobileMenuOverlay()
})

const closeAll = async () => {
  closeSearchOverlay()
  closeMobileMenuOverlay()
  closeMainNavItems()
  closeTopBarSubNav()
}


document.body.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    window.dispatchEvent(new CustomEvent('menus:close'))
    window.dispatchEvent(new CustomEvent('widgets:close'))
  }
})

window.addEventListener('menus:close', async e => closeAll())

mainNavItems.forEach(item => {

  item.closeButton.addEventListener('click', async e => {
    await closeMainNavItems()
  })

  item.button.addEventListener('click', async e => {
    e.preventDefault()

    const isAlreadyOpen = item.original.classList.contains('nav-item-open')

    await closeSearchOverlay()
    await closeSearchOverlay()
    await closeMainNavItems()
    await closeTopBarSubNav()

    if (!isAlreadyOpen) {
      await openMainNavItem(item)
    }
  })

})

topBarSubNav.forEach(item => {
  item.addEventListener('click', async e => {
    e.preventDefault()
    someMenuOpen()
    e.target.parentElement.classList.toggle('open')
  })
})
